































































































































helpers = require('../../../helpers.coffee')
listItem = require('./property_item.vue')
on_clickaway = require('vue-clickaway')

view_model =
  mixins: [ on_clickaway.mixin ]

  components:
    draggable: require('vuedraggable')
    newCustomFieldsModal: require('../../custom_fields/new_modal')

  props: ['properties_matching', 'integration_name', 'api_fields']

  data: ->
    current_user: Session.current_user
    reev_fields: []
    original_reev_fields: []
    matching: []
    custom_fields: []
    edit_custom_field: new CustomField()
    template: listItem
    attrs: {
      placeholder: this.$t('integrations.placeholder.properties_matching')
    }
    filter: []

  methods:
    updateProperty: (field) ->
      return if !field
      idx = undefined
      reev_field = @reev_fields.find( (r_field) -> r_field.key == field.key  )
      reev_field.matching = true

      for item, index in @api_fields
        if @filter[item.key]
          idx = index

      if idx != undefined
        new_element = { reev: field.key, reev_name: field.name, integration: '', integration_name: '' }
        @matching[idx] = new_element
        @doMath()
        @matchingUpdated(@matching)

      @reev_fields = @original_reev_fields.filter (field) -> !field.matching
      @filter = []

    api_field_class: (field) ->
      str_required = 'not-required'
      str_required = 'required' if field?.required

      return([str_required])

    updateAutocomplete: (text) ->
      return @reev_fields = @original_reev_fields if !text
      @reev_fields = @original_reev_fields.filter (field) -> field.name.indexOf(text) > -1

    getLabel: (field) ->
      return field.name if field != null
      undefined

    onClickaway: ->
      @$emit('hide')

    defaultFields: (removed_key = null) ->
      [
        { name: this.$t('integrations.attributes.url'), key: 'url', type: 'input' }
        { name: 'LinkedIn', key: 'linkedin', type: 'input' }
        { name: this.$t('integrations.attributes.position'), key: 'position', type: 'input' }
        { name: this.$t('integrations.attributes.telephone'), key: 'telephone', type: 'tel' }
        { name: this.$t('integrations.attributes.cellphone'), key: 'cellphone', type: 'tel' }
        { name: this.$t('integrations.attributes.address'), key: 'address', type: 'input' }
        { name: this.$t('integrations.attributes.variable') + ' 1', key: 'variable1', type: 'input' }
        { name: this.$t('integrations.attributes.variable') + ' 2', key: 'variable2', type: 'input' }
        { name: this.$t('integrations.attributes.variable') + ' 3', key: 'variable3', type: 'input' }
      ].filter (field) =>
        return true unless @properties_matching?
        !(@properties_matching.find (matching) -> matching.reev == field.key && removed_key != field.key)

    loadCustomFieldsSuccess: (data) ->
      @reev_fields = @reev_fields.filter (filter) -> !filter.custom
      custom_in = false
      for custom in data.custom_fields
        for item in @properties_matching
          if item.reev == custom.field
            custom_in = true
            break
          else
            custom_in = false
        if custom_in == false
          @reev_fields.push { custom: true, name: custom.field, key: custom.field, type: custom.kind }
      @original_reev_fields = @reev_fields

    autoMatchFields: ->
      for field in @matching
        math = @reev_fields.find (reev) -> reev.key == field.integration
        if math
          field.reev = math.key
          field.reev_name = math.name
          math.matching = true

    mountDefaultFields: ->
      for field in @matching
        math = @properties_matching.find (reev) -> reev.integration == field.integration && reev.origin == field.origin
        if math
          field.reev = math.reev
          field.reev_name = math.reev_name
          math.matching = true

    matchingChanged: (event) ->
      if event.added
        event.added.element.matching = true
        removed = @matching.splice(event.added.newIndex + 1, 1)
        @read_option(removed)
      else if event.removed
        event.removed.element.matching = false
        new_element = { reev: '', reev_name: '', integration: event.removed.element.integration, integration_name: event.removed.element.integration_name }
        removed = @matching.splice(event.removed.oldIndex, 0, new_element)
        @read_option(removed)
      else if event.moved
        new_element = { reev: '', reev_name: '', integration: event.moved.element.integration, integration_name: event.moved.element.integration_name }
        @matching[event.moved.oldIndex] = new_element
      @doMath()

    read_option: (removed) ->
      for field in removed
        found = @reev_fields.find((item) -> item.name == field.reev_name )
        if (found == undefined && field.reev_name != '')
          @reev_fields.push({
            integration: "",
            key: field.reev,
            matching: false,
            name: field.reev_name,
            type: field.type
          })

    removeField: (field, idx) ->
      reev_field = @reev_fields.find( (r_field) -> r_field.key == field.reev  )
      if reev_field
        reev_field.matching = false
      else
        reev_field = @defaultFields(field.reev).find( (r_field) -> r_field.key == field.reev  )
        if reev_field
          @reev_fields.push(reev_field)
        else
          @reev_fields.push({ name: field.reev_name, key: field.reev, type: field.type })
      new_element = { reev: '', reev_name: '', integration: '', integration_name: '' }
      @matching[idx] = new_element
      @doMath()
      @matchingUpdated(@matching)

    doMath: ->
      for field, idx in @matching
        field.integration = @api_fields[idx].key
        field.integration_name = @api_fields[idx].name

    matchingUpdated: (updated) ->
      api_fields = @api_fields
      array = updated.map (obj, idx) -> { reev: obj.key || obj.reev, reev_name: obj.name || obj.reev_name, integration: api_fields[idx]?.key, integration_name: api_fields[idx]?.name, type: api_fields[idx]?.type, origin: api_fields[idx]?.origin, matching: true }
      @matching = array
      @$emit('matching-updated', array)

    reevFieldsUpdated: (updated) ->
      array = updated.map (obj) -> { key: obj.key || obj.reev, name: obj.name || obj.reev_name, type: obj.type, matching: false, integration: '' }
      @reev_fields = array

    onMove: (context) ->
      relatedElement = context.relatedContext.element;
      draggedElement = context.draggedContext.element;
      return (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed

    openModal: ->
      jQuery("#new-custom-fields-modal").modal 'show'

    closeCreateModal: ->
      @edit_custom_field = new CustomField()
      jQuery("#new-custom-fields-modal").modal 'hide'

    custom_field_created: (custom_field) ->
      @closeCreateModal()
      @reev_fields.push { custom: true, name: custom_field.field, key: custom_field.field, type: custom_field.kind }
      @original_reev_fields = @reev_fields

    loadCustomFields: ->
      new CustomFieldsResource().index(@loadCustomFieldsSuccess, null, {})

    validateApiFields: ->
      @matching = @api_fields.map (field) -> { reev: '', reev_name: '', integration: field.key, integration_name: field.name, type: field.type, origin: field.origin }
      if @properties_matching?.length != @api_fields.length
        @mountDefaultFields()
      else
        @matching = @properties_matching
      @matchingUpdated(@matching)

    loadFields: ->
      @reev_fields = @defaultFields()
      @loadCustomFields()

  computed:
    api_fields_person: ->
      @api_fields.filter (field) -> !field.origin || (field.origin != 'deal' && field.origin != 'Oportunidade')

    matching_person: ->
      @matching.filter (field) -> !field.origin || (field.origin != 'deal' && field.origin != 'Oportunidade')

    api_fields_deal: ->
      @api_fields.filter (field) -> field.origin == 'deal' || field.origin == 'Oportunidade'

    matching_deal: ->
      @matching.filter (field) -> field.origin == 'deal' || field.origin == 'Oportunidade'

    draggable_options: ->
      {
        animation: 0,
        group: "description",
        disabled: false
      }

  watch:
    api_fields: ->
      @validateApiFields()

    properties_matching: ->
      @validateApiFields()
      @loadFields()

  mounted: ->
    Tooltip.initialize()
    @loadFields()
    @validateApiFields()

exports.default = helpers.vue_include(view_model, helpers.form)




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/configuration/integrations/properties_matching.vue